import React from "react"
import {useStore, useDispatch} from "../Store"
import {isAmOne} from "../common"
import {useTranslation} from "react-i18next"
import "../i18n"
import VirtualSelect from "../components/VirtualSelect"

export default function SelectCategory({id = null}) {
  const {t} = useTranslation()
  const {dispatch} = useDispatch()
  const {
    store: {perspective, tabs, mainType, mainGroup, mainCategory, categoryList, categoryCodeList, locale},
  } = useStore()

  const handleChange = (values) => {
    if (!values) {
      const value = [
        {
          type: null,
          value: null,
          labelEn: ``,
          labelJa: ``,
        },
      ]
      categoryCodeList[perspective] = value
      dispatch({
        type: `SET_CATEGORY_CODE`,
        categoryCodeList,
      })
      return
    }
    categoryCodeList[perspective] = values
    dispatch({
      type: `SET_CATEGORY_CODE`,
      categoryCodeList,
    })
  }

  const label = t(mainCategory[perspective]) /* i18next-extract-disable-line */
  return (
    <VirtualSelect
      multiple={false}
      id={id}
      target={`category`}
      label={locale === `ja` ? `labelJa` : `labelEn`}
      inputLabel={label}
      options={categoryList[perspective]}
      onChange={handleChange}
      value={categoryCodeList[perspective]}
    />
  )
}
